module.exports = function(name) {
	var a = load(require, name);
	var r = require;
	var b = r(name);
	if(a !== b) return "FAIL";
	return a;
}

function load(requireFunction, name) {
	return requireFunction(name);
}


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/context/templates/templateLoaderIndirect.js
 ** module id = 8
 ** module chunks = 0
 **/